import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import router from './router/index.tsx';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import {
  publicClientApplication,
  scopes,
} from './authentication/PublicClientApplication';

publicClientApplication.initialize().then(async () => {
  // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/v1-migration.md#3-update-your-code
  const authenticationResult =
    await publicClientApplication.handleRedirectPromise();

  if (authenticationResult === null) {
    const accounts = publicClientApplication.getAllAccounts();

    if (accounts.length === 0) {
      publicClientApplication.loginRedirect({ scopes });
    }
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={publicClientApplication}>
        <RouterProvider router={router} />
      </MsalProvider>
    </React.StrictMode>
  );
});
